import { Box } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../utils/datahooks';
import { CompletedTask } from '../../rule-layout/completed-task/completed-task';
export const ToggleFixerCompletedState = _ref => {
  var _ruleResult$fixerProp, _ruleResult$fixerProp2;
  let {
    ruleResult,
    description
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(CompletedTask, {
    completedValue: (_ruleResult$fixerProp = ruleResult.fixerProps) == null ? void 0 : _ruleResult$fixerProp.completedRuleContent.value,
    dataHook: dataHooks.completedTaskToggleFixer(ruleResult.dataHook),
    description: description,
    editButtonLabel: ruleResult.fixerProps.completedRuleContent.editButtonLabel,
    inputLabel: (_ruleResult$fixerProp2 = ruleResult.fixerProps) == null ? void 0 : _ruleResult$fixerProp2.completedRuleContent.inputTitle,
    isEditable: ruleResult.isEditableOnceCompleted,
    title: ruleResult.fixerProps.completedRuleContent.title
  }));
};
//# sourceMappingURL=toggle-rule-completed-state.js.map